import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import productReducer from "../features/product/productSlice";
import brandReducer from "../features/brand/brandSlice";
import featureReducer from "../features/feature/featureSlice";
import brandModelReducer from "../features/brandModel/brandModelSlice";
import clientReducer from "../features/clients/clientSlice";
import sizeReducer from "../features/size/sizeSlice"
import enquiryReducer from "../features/enquiry/enquirySlice";
import uploadReducer from "../features/upload/uploadSlice";
 import bookingReducer from "../features/booking/bookingSlice";
import blogReducer from "../features/blogs/blogSlice";
 

export const store = configureStore({
  reducer: {
    auth: authReducer,
    product: productReducer,
    brand: brandReducer,
    feature: featureReducer,
    brandModel: brandModelReducer,
    size:sizeReducer,
    clients: clientReducer,
    enquiry: enquiryReducer,
    booking:bookingReducer,
    upload: uploadReducer,
   blogs: blogReducer,
  },
});
